import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { store } from './store'
import axios from 'axios'

import VueMask from 'v-mask'
Vue.use(VueMask)

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru.json'
import * as rules from 'vee-validate/dist/rules'
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})
localize('ru', ru)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

import { faBars } from '@fortawesome/free-solid-svg-icons'
library.add(faBars)

import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
library.add(faEnvelope)

import { faUserCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faUserCircle)

import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
library.add(faCaretRight)

import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
library.add(faCaretDown)

import { faPaperclip } from '@fortawesome/free-solid-svg-icons'
library.add(faPaperclip)

import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
library.add(faEllipsisH)

import { faDownload } from '@fortawesome/free-solid-svg-icons'
library.add(faDownload)

import { faUser } from '@fortawesome/free-solid-svg-icons'
library.add(faUser)

import { faClock } from '@fortawesome/free-solid-svg-icons'
library.add(faClock)

import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
library.add(faArrowAltCircleRight)

import { faFileSignature } from '@fortawesome/free-solid-svg-icons'
library.add(faFileSignature)

import { faFileAlt } from '@fortawesome/free-solid-svg-icons'
library.add(faFileAlt)

import { faFilePen } from '@fortawesome/free-solid-svg-icons'
library.add(faFilePen)

import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
library.add(faCirclePlus)

import { faPlus } from '@fortawesome/free-solid-svg-icons'
library.add(faPlus)

import { faMinus } from '@fortawesome/free-solid-svg-icons'
library.add(faMinus)

import { faUpload } from '@fortawesome/free-solid-svg-icons'
library.add(faUpload)

import { faXmark } from '@fortawesome/free-solid-svg-icons'
library.add(faXmark)

import { faPencil } from '@fortawesome/free-solid-svg-icons'
library.add(faPencil)

import { faTrash } from '@fortawesome/free-solid-svg-icons'
library.add(faTrash)

import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faQuestionCircle)

import { faFingerprint } from '@fortawesome/free-solid-svg-icons'
library.add(faFingerprint)

import { faFolderOpen } from '@fortawesome/free-solid-svg-icons'
library.add(faFolderOpen)

import { faClone } from '@fortawesome/free-solid-svg-icons'
library.add(faClone)

import { faCalendar } from '@fortawesome/free-solid-svg-icons'
library.add(faCalendar)

import { faFileArchive } from '@fortawesome/free-solid-svg-icons'
library.add(faFileArchive)

import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
library.add(faFilePdf)

import { faFileImage } from '@fortawesome/free-solid-svg-icons'
library.add(faFileImage)

import { faFileWord } from '@fortawesome/free-solid-svg-icons'
library.add(faFileWord)

import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
library.add(faFileExcel)

import { faFileCsv } from '@fortawesome/free-solid-svg-icons'
library.add(faFileCsv)

import { faFileCode } from '@fortawesome/free-solid-svg-icons'
library.add(faFileCode)

import { faFilePowerpoint } from '@fortawesome/free-solid-svg-icons'
library.add(faFilePowerpoint)

import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons'
library.add(faFloppyDisk)

import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faTimesCircle)

import { faFile } from '@fortawesome/free-solid-svg-icons'
library.add(faFile)

Vue.config.productionTip = false

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common.Authorization = token
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
